module.exports = __webpack_public_path__ + "img/YTDRep.a4fb07df.svg";